import { shallowMount } from "@vue/test-utils";
import TextInput from "@/components/core/TextInput";

describe("TextInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(TextInput);
  });

  it("Renders del component TextInput", () => {
    expect(wrapper).toBeDefined();
  });
});
